import { Injectable } from '@angular/core';
import { WebUserDataConstants } from '@ddt-web/domain';
import * as has from 'lodash/has';

@Injectable()
export class SavedAndSubscribedFactory {
	public getSavedIds(responseJson: any, tooldId: string): string[] {
		let savedIds = [];

		const savedPreference: any = this.getSavedMaster(responseJson);

		if (!savedPreference) {
			return savedIds;
		}

		savedIds = this.getIds(savedPreference, tooldId, 'user.BlkSavedModels.masterList');

		return savedIds;
	}

	public getSubscribedIds(responseJson: any, tooldId: string): string[] {
		let subscribedIds = [];

		const subscribedPreference: any = this.getSubscribedMaster(responseJson);

		if (!subscribedPreference) {
			return subscribedIds;
		}

		subscribedIds = this.getIds(subscribedPreference, tooldId, 'user.BlkSubscribedModels.masterList');

		return subscribedIds;
	}

	public getDeltaIds(responseJson: any): string[] {
		let deltaIds = [];

		if (!has(responseJson, 'result.resultList.deltaUniqueIds')) {
			return deltaIds;
		}

		deltaIds = responseJson.result.resultList.deltaUniqueIds;

		return deltaIds;
	}

	public getSavedMaster(responseJson: any): any {
		if (!has(responseJson, 'result.resultList.savedPreference')) {
			return undefined;
		}

		return responseJson.result.resultList.savedPreference;
	}

	public getSubscribedMaster(responseJson: any): any {
		if (!has(responseJson, 'result.resultList.subscribedPreference')) {
			return undefined;
		}

		return responseJson.result.resultList.subscribedPreference;
	}

	private getIds(responseJson: any, tooldId: string, preferenceKey: string): string[] {
		const ids = [];

		if (responseJson.type && responseJson.type === WebUserDataConstants.TYPE.PORTFOLIO_LIKE && responseJson.preferenceKey && responseJson.preferenceKey === preferenceKey) {
			responseJson.children.forEach(child => ids.push(child.identifier));
		}

		return ids;
	}
}
